import UserClaimDetails from './UserClaimDetails';

export default UserClaimDetails;
